import { Component } from 'react';
import appLogger from '../logging/app_logger';

interface ErrorBoundaryState {
    error: any;
    errorInfo: any;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: { children: React.ReactNode }) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error: any, errorInfo: any) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        appLogger.error('ErrorBoundary triggered: ', { error, errorInfo });
    }

    render() {
        if (this.state.error) {
            // we can display anything we like
            // as long as it is not from our component library
            return <div></div>;
        } else {
            return this.props.children;
        }
    }
}
